import { Empty } from "gui/empty/empty";

export function BrowseUsersEmpty() {
  return (
    <Empty icon="circle-fill" title="No matching wizards">
      <p>There are no wizards matching your search.</p>
    </Empty>
  );
}
